import { type } from '@ngrx/signals';
import { eventGroup } from '@ngrx/signals/events';

export const messagingPageEvents = eventGroup({
  source: 'Messaging',
  events: {
    messageSent: type<{ patientId: number; messageId: number }>(),
    chatOpened: type<{ patientId: number }>(),
    patientIdSelected: type<{ patientId: number }>(),
  },
});
